import React from "react";
import ForSaleEssentialsList from "./for-sale-essentials-list/for-sale-essentials-list";

const ForSaleEssentialsContainer = () => {
    return (
        <>
            <div style={{ padding: 20 }}>
                <ForSaleEssentialsList/>
            </div>
        </>
    )
};

export default ForSaleEssentialsContainer;